import TopDownDistributionPanel from './TopDownDistributionPanel';

export default TopDownDistributionPanel;
